$(window).load(function(){
    $('.video_iframe_v2').hide();
    if($('.video_iframe_v2').children('iframe').length) {

        var iframe_src       = $('.video_iframe_v2').children('iframe').attr('src');
        var youtube_video_id = iframe_src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();

        $('.js-videoPoster').css('background', 'url(https://img.youtube.com/vi/' + youtube_video_id + '/0.jpg) 50% 50%');
        $('.js-videoPoster').css('height','83%');

        var $src_video_iframe_v2 = $(".video_iframe_v2 iframe").attr("src");
        $new_src = $src_video_iframe_v2 + "?autoplay=1&modestbranding=1&rel=0&hl=ru&showinfo=0&color=white";
        $(".video_iframe_v2 iframe").attr("data-src", $new_src);
        $(".video_iframe_v2 iframe").attr("src", "");
        $(".video_iframe_v2 iframe").attr("allowtransparency", "true");
        $(".video_iframe_v2 iframe").attr("allowfullscreen");

        $('.video_iframe_v2').show();

        $(document).on('click', '.js-videoPoster', function (e) {
            e.preventDefault();
            var poster = $(this);
            var wrapper = poster.closest('.video_iframe_v2');
            videoPlay(wrapper);
        });

        function videoPlay(wrapper) {
            var iframe = $(".video_iframe_v2 iframe");
            var src = iframe.attr("data-src");
            wrapper.addClass('videoWrapperActive');
            iframe.attr("src", src);

            $('.js-videoPoster').fadeOut('800' , function () {
                $('.js-videoPoster').css('height','auto');
            });
        }
    }

    });